var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.app.isDownloading)?_c('div',{staticClass:"core-loader small"},[_c('div',{staticClass:"stream_spiner mb-0"}),_c('p',{staticClass:"main-subtitle pl-0 mb-0"},[_vm._v(_vm._s(_vm.$t("loading"))+"...")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }